import React from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';

import SVG from 'components/SVG';
import Button from 'components/Button';
import './SocialMedia.scss';
import Input from 'components/Input';
import useSocialMedia from 'features/creativeFunctionality/models/socialMediaModel';
import { socialList } from 'features/creativeFunctionality/data';

const b = block('social-media');

const SocialMedia = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const model = useSocialMedia();
  return (
    <div className={b()}>
      <div className={b('header')}>
        <h1 className={b('header-title')}>{locale.socialMedia}</h1>
        <span className={b('header-total')}>
          {locale.totalSocialMedia}: {model.values.socialLinksCount}
        </span>
      </div>
      <div className={b('content')}>
        <div className={b('title')}>{locale.insertASocialMediaLinkToAddIt}</div>
        {socialList.map(item => {
          const value = model.values.state[item.name];
          return (
            <div key={item.name} className={b('item')}>
              <SVG className={b('item-icon')} svgProps={{ svg: item.icon }} />
              <div className={b('item-input')}>
                <Input
                  value={value}
                  placeholder={locale.insertLinkToSocialMedia}
                  onChange={e =>
                    model.handlers.handleSocialLinkChange({ social: item.name, link: e.currentTarget.value })
                  }
                />
              </div>
              <div className={b('item-button')}>
                <Button
                  callBack={() => model.handlers.handleUpdateLink({ [item.name]: value })}
                  text={model.values.socialMedia[item.name] ? locale.change : locale.add}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SocialMedia;
